import { createApiClient } from '@/infrastructure/api/client'
import { AccountRepository } from '@/infrastructure/repositories/account.repository'
import { AccountService } from '@/domain/services/account.service'
import { getXLocation } from '@/utils/http-headers'
import type { AxiosRequestConfig } from 'axios'

let cachedService: AccountService | null = null

/**
 * Композабл для сервиса аккаунтов (accounts).
 * Использует общий экземпляр API-клиента и сервиса.
 */
export function useAccountService(): AccountService {
  if (!cachedService) {
    const config = useRuntimeConfig()
    const apiClient = createApiClient({
      baseUrl: config.public.NUXT_APP_LANDING_API,
      onRequest: (axiosConfig: AxiosRequestConfig) => {
        // Динамически добавляем заголовок X-Location при каждом запросе
        if (axiosConfig.headers) {
          axiosConfig.headers['X-Location'] = getXLocation()
        }
      },
    })
    const accountRepository = new AccountRepository(apiClient)
    cachedService = new AccountService(accountRepository)
  }
  return cachedService
}
